import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

export default function usePeople() {
  const [people, setPeople] = useState([])
  const [pastCollaborators, setPastCollaborators] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchPeople() {
      try {
        setLoading(true)
        setError(null)

        const { data, error: fetchError } = await supabase
          .from('people')
          .select('*')

        if (fetchError) {
          throw fetchError
        }

        // Transform the data to match the existing structure
        const transformedPeople = data.map(person => ({
          name: person.name,
          image: person.image ? (person.image.startsWith('http') ? person.image : process.env.PUBLIC_URL + person.image) : process.env.PUBLIC_URL + "/images/defaultpic.png",
          title: person.title,
          bio: person.bio,
          linkedin: person.linkedin,
          website: person.website,
          email: person.email,
          github: person.github,
          projectsCategory: person.projects_category ? person.projects_category.split(',').map(cat => cat.trim()) : [],
          current: person.current !== false, // Default to true if null
          orderPriority: person.order_priority,
          id: person.id,
          createdAt: person.created_at,
          updatedAt: person.updated_at
        }))

        // Separate current and past collaborators
        const current = transformedPeople.filter(person => person.current)
        const past = transformedPeople.filter(person => !person.current)

        // Sort function: order_priority first (nulls last), then alphabetically by name
        const sortPeople = (a, b) => {
          // If both have order_priority, sort by that
          if (a.orderPriority != null && b.orderPriority != null) {
            return a.orderPriority - b.orderPriority
          }
          // If only one has order_priority, it comes first
          if (a.orderPriority != null) return -1
          if (b.orderPriority != null) return 1
          // Otherwise, sort alphabetically by name
          return a.name.localeCompare(b.name)
        }

        setPeople(current.sort(sortPeople))
        setPastCollaborators(past.sort(sortPeople))
      } catch (err) {
        console.error('Error fetching people:', err)
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchPeople()
  }, [])

  return { people, pastCollaborators, loading, error }
}
